import ResizeObserver from 'resize-observer-polyfill';
import * as _Elements from "./elements/index.mjs";
export { _Elements as Elements };
export { stringifyNode } from "./lib/index.mjs";
export { Component, Selector } from "./selector/index.mjs";
import * as _Transformations from "./transformations/index.mjs";
export { _Transformations as Transformations };
export { Renderer } from "./Renderer.mjs";
if (typeof window !== 'undefined') {
  var _window$ResizeObserve;
  window.ResizeObserver = (_window$ResizeObserve = window.ResizeObserver) !== null && _window$ResizeObserve !== void 0 ? _window$ResizeObserve : ResizeObserver;
}